// Timeout constants
export const ANALYZE_DATA_TIMEOUT = 100;

